<template>
  <div class="panel">
    <div class="panel-heading pb-80">
      <div class="row">
        <div class="col-6">
          <h3 class="panel-title text-center">
            Детализация причин
            <i class="icon md-help-outline cursor-pointer"
               aria-hidden="true"
               data-toggle="popover"
               data-html="true"
               data-trigger="click | hover"
               data-content="Рассчитывается на основании человек-группа"></i>
          </h3>
        </div>
        <div class="col-6">
          <select class="form-control" v-model="month" @change="selectMonth">
            <option value="0">Месяц (Все)</option>
            <option v-for="n in 12" :value="n" v-model="month">{{ monthByNum(n) }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="report-content">
        <span v-if="error" class="error status_padding">
            <h6 class="text-center">По группам нет статистики</h6>
        </span>

        <span v-if="!error && loading" class="loading status_padding">
            <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
        </span>

        <GChart
            v-if="active_tab == 2 && !error && !loading"
            type="PieChart"
            :data="chartData"
            :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {GChart} from 'vue-google-charts/legacy';


export default {
  name      : 'DetailsOfReasonsByMonthsDiagram',
  components: {
    GChart,
  },
  props: [
      'active_tab'
  ],
  data() {
    return {
      loading     : true,
      error       : false,
      month       : 0,
      chartOptions: {
        legend : {position: 'none'},
        pieHole: 0.4,
        colors : [],
        height : 400,
        width  : '100%',
      },
      chartCounts : [],
      types       : {
        'not_informed' : {
          'title': 'Своевременно не проинформированы',
          'color': '#3a87ad',
        },
        'ignoring'     : {
          'title': 'Игнорирование назначенного обучения',
          'color': '#7a43b6',
        },
        'not_completed': {
          'title': 'Не завершили обучение в установленные сроки',
          'color': '#9d261d',
        },
        'not_passed'   : {
          'title': 'Допущенные, но не сдававшие экзамен',
          'color': '#f89406',
        },
      },
    };
  },
  computed: {
    chartData() {
      return [
        ['c0', 'c1'],
        ...this.chartCounts,
      ];
    },
  },
  methods : {
    getData() {
      axios.get(`/widgets/DetailsOfReasonsByMonths/${ this.month }`).then((response) => {
        let colors  = [];
        let counts  = [];
        let fetched = false;

        Object.keys(response.data).map((key) => {
          colors.push(this.types[key].color);
          counts.push([
            this.types[key].title,
            response.data[key],
          ]);

          if (response.data[key] > 0) {
            fetched = true;
          }
        });

        this.chartOptions.colors = colors;
        this.chartCounts         = counts;

        if (!fetched) {
          this.error = true;
        }

        this.loading = false;
      }).catch((err) => {
        console.log(err);
        this.error = true;
      });
    },
    monthByNum(n) {
      const date = new Date();
      date.setMonth(n - 1);

      const monthName = date.toLocaleString('ru-RU', {
        month: 'long',
      });

      return `${ monthName[0].toUpperCase() }${ monthName.slice(1) }`;
    },
    selectMonth() {
      this.loading             = true;
      this.error               = false;
      this.chartCounts         = [];
      this.chartOptions.colors = [];
      this.getData();
    },
  },
  created() {
    this.$nextTick(function () {
      this.getData();
    })
  },
};
</script>

<style scoped>
.md-help-outline {
  color: #ff6611;
}

.report-content {
  width: 100%;
}

select.form-control {
  margin-top: 1rem;
  width: 90%;
}
</style>
